import { render, staticRenderFns } from "./userHeader.vue?vue&type=template&id=268cf440&scoped=true&"
import script from "./userHeader.vue?vue&type=script&lang=js&"
export * from "./userHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268cf440",
  null
  
)

export default component.exports